module.exports = __webpack_public_path__ + "static/img/PC-3.1430262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcyixuekao/PC-3.png
// module id = VBb7
// module chunks = 0